import { z } from 'zod';

import { WidgetType } from '../../utils/widgetsUtils';

export const BaseWidgetSchema = <T extends WidgetType>(widgetType: T) =>
  z.object({
    id: z.string(),
    type: z.literal(widgetType),
    children: z.array(z.string())
  });
